import React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const RestrictedScreenNotice = ({ title }) => (
    <div className="restricted-screen-card">
        <h2 className="page-title-master">{title}</h2>
        <Stack sx={{ width: '100%', marginTop: '10px' }} spacing={2}>
            <Alert severity="info">
                This section includes detailed charts and dense data views that are best experienced on a laptop or a larger screen. Please switch to a desktop or tablet in landscape mode for the full experience.
            </Alert>
        </Stack>
    </div>
);

export default RestrictedScreenNotice;
